import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { AiDisclaimer } from "@/components/ai-documents/ai-disclaimer";
import { BulkProgress } from "@/components/ai-documents/bulk/bulk-progress";
import { Link } from "@/core/lib/navigation";
import { BLANK_DOCUMENT_TYPE } from "@/lib/blank-document";
import { fetchBatch } from "@/lib/bulk-generate-api";

export const Route = createFileRoute("/_workspace/generate/bulk/$batchId")({
  component: BulkBatchPage,
});

function BulkBatchPage() {
  const { batchId } = Route.useParams();
  // Shares BulkProgress's cache entry (and its polling) — read here only to
  // tell a blank-document batch, written by the user, from an AI one.
  const { data: batch } = useQuery({
    queryKey: ["batch", batchId],
    queryFn: () => fetchBatch(batchId),
  });
  const isBlank = batch?.documentTypes.includes(BLANK_DOCUMENT_TYPE) ?? false;
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-4xl space-y-6">
        <Link
          href="/generate"
          className="inline-flex items-center gap-1.5 text-muted-foreground text-sm underline-offset-4 hover:underline"
        >
          <ArrowLeftIcon className="size-4" />
          Back to Generate
        </Link>
        <div className="space-y-1">
          <h1 className="font-bold text-2xl tracking-tight">Bulk generation</h1>
          <p className="text-muted-foreground text-sm">
            Track progress and review each generated document.
          </p>
        </div>
        <BulkProgress batchId={batchId} />
        {batch && !isBlank && <AiDisclaimer />}
      </div>
    </main>
  );
}
